import React, { useEffect, useState } from "react";
import { ZomentumRoutes } from "@/Contracts";

import { Row, Col } from "antd";
import "./PaymentModals.less";

import CheckCircleIcon from "config/assets/Icons/CheckCircleIcon.svg";
import PersonImg from "@/Assets/Others/PaymentModal/PersonImg.svg";
import FlowersImg from "@/Assets/Others/PaymentModal/FlowersImg.svg";
import { BillingInfo } from "@/Contracts/Users";
import CardFormComponent from "./CardFormComponent";
import { useSelector } from "react-redux";
import UsersActionCreators from "@/Actions/User";
import { EIcons } from "@atoms/ZIcon/interface";
import ZIcon from "@atoms/ZIcon";
import { EColors } from "@atoms/ZColors/interface";
import { GlobalState } from "@/Reducers/interface";
import { ZButton, ZTypography, ZModal } from "@atoms";
import { EFontWeights } from "@atoms/ZTypography/interface";
import useDispatch from "@/Components/Utils/useDispatch";
import { ZMessage } from "@molecules";

const { ZText } = ZTypography;

export interface Props {
	showCardModalForced?: boolean;
	closeCardModal?: boolean;
	onCardSubmitSuccess?: () => void;
	onClose?: () => void;
}

const AddCardModal: React.FC<Props> = props => {
	const [cardFormOpen, setCardFormOpen] = useState(false);
	const { showAddCardModal, user, isLoading } = useSelector(
		(state: GlobalState) => {
			return {
				showAddCardModal:
					!window.location.href.includes(ZomentumRoutes.Authorize) &&
					!window.location.href.includes(
						ZomentumRoutes.SetupAccount
					) &&
					BillingInfo.paymentNeeded(state.user.billingInfo),
				user: state.user.billingInfo,
				isLoading: state.user.isBillingInfoLoading
			};
		}
	);
	const dispatch = useDispatch();

	const getBillingInfoDispatch = () =>
		dispatch(UsersActionCreators.getBillingInfo());
	const showBillingInfoLoaderDispatch = () =>
		dispatch(UsersActionCreators.showBillingInfoLoader());
	const hideBillingInfoLoaderDispatch = () =>
		dispatch(UsersActionCreators.hideBillingInfoLoader());
	const subscriptionDetailsDispatch = () =>
		dispatch(UsersActionCreators.getSubscriptionDetails());

	useEffect(() => {
		getBillingInfo();
	}, []);

	const getBillingInfo = async () => {
		try {
			showBillingInfoLoaderDispatch();
			const { billingInfo } = await getBillingInfoDispatch();
			if (
				!showAddCardModal &&
				!billingInfo.is_internal &&
				!window.location.href.includes(ZomentumRoutes.Authorize) &&
				!window.location.href.includes(ZomentumRoutes.SetupAccount)
			) {
				await subscriptionDetailsDispatch();
			}
		} catch (error) {
			console.error(error);
		} finally {
			hideBillingInfoLoaderDispatch();
		}
	};

	const cardFormComponentSubmit = async () => {
		cardFormComponentClosed();
		await dispatch(UsersActionCreators.confirmCardAdded());
		ZMessage.success("Card details successfully captured!");
		props.onCardSubmitSuccess?.();
	};

	const cardFormComponentClosed = () => {
		setCardFormOpen(false);
	};

	return (
		<ZModal
			closable={props.closeCardModal ?? false}
			visible={props.showCardModalForced ?? showAddCardModal}
			closeIcon={
				<ZIcon
					name={EIcons.CANCEL}
					color={EColors.GRAY}
					colorVariant={1}
					size="sm"
				/>
			}
			maskClosable={false}
			onCancel={props.onClose}
			footer={null}
			size="lg"
			centered
			bodyStyle={{
				borderRadius: "0px",
				background: "#ffffff",
				padding: "0px"
			}}
			zIndex={999999999} // this is to override user pilot iframe zIndex
		>
			<Row>
				<Col span={12}>
					<div className="grid align-center my-61">
						<ZText weight={EFontWeights.MEDIUM} level={2}>
							{BillingInfo.promptMessageForPayment(user)}
						</ZText>
						<ZButton
							type="primary"
							className="my-4 mx-auto"
							loading={isLoading}
							disabled={isLoading}
							onClick={() => setCardFormOpen(true)}
						>
							Manage Payment Method
						</ZButton>
					</div>
					{cardFormOpen && (
						<CardFormComponent
							onSubmit={cardFormComponentSubmit}
							onClose={cardFormComponentClosed}
						/>
					)}
				</Col>
				<Col span={12}>
					<div className="payment-info-container">
						<Row justify="center" align="top">
							<Col span={4}>
								<CheckCircleIcon className="payment-info-item" />
							</Col>
							<Col span={20}>
								<ZText className="payment-info-item">
									Sales funnel management
								</ZText>
							</Col>
							<Col span={4}>
								<CheckCircleIcon className="payment-info-item" />
							</Col>
							<Col span={20}>
								<ZText className="payment-info-item">
									Proposals and quotes
								</ZText>
							</Col>
							<Col span={4}>
								<CheckCircleIcon className="payment-info-item" />
							</Col>
							<Col span={20}>
								<ZText className="payment-info-item">
									Digital Signatures
								</ZText>
							</Col>
							<Col span={4}>
								<CheckCircleIcon className="payment-info-item" />
							</Col>
							<Col span={20}>
								<ZText className="payment-info-item">
									Insights {"&"} analytics
								</ZText>
							</Col>
							<PersonImg className="person-img" />
							<FlowersImg className="flowers-img" />
						</Row>
					</div>
				</Col>
			</Row>
		</ZModal>
	);
};

export default AddCardModal;
